import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import CartState from '../types/CartState'

export const module: Module<CartState, any> = {
  namespaced: true,
  state: {
    isCartLoading: false,
    isMicrocartOpen: false,
    itemsAfterPlatformTotals: {},
    platformTotals: null,
    platformTotalSegments: null,
    cartIsLoaded: false,
    cartServerToken: '', // server side ID to synchronize with Backend (for example Magento)
    shipping: [],
    payment: [],
    cartItemsHash: '',
    cartServerLastSyncDate: 0,
    cartServerLastTotalsSyncDate: 0,
    cartQuantity: 0,
    serviceFee: 0,
    groupedCart: [],
    cartItems: [] // TODO: check if it's properly namespaced
  },
  getters,
  actions,
  mutations
}
